import { Dictionary } from "vue-router/types/router";

import { getQueryStringValue } from "@/helpers";
import { IPromotionRequestModel } from "@/models";

export default function getPromotionRequestModel(
    query: Dictionary<string | (string | null)[]>,
    slug: string
): IPromotionRequestModel {
    const givenPromotionCode = getQueryStringValue(
        query as Record<string, string>,
        "promotionCode"
    );

    return {
        slug: slug,
        promotionCode: givenPromotionCode,
        url: window.location.href
    };
}
